export default __webpack_public_path__ + "static/media/dg.99186972.svg";